document.addEventListener('DOMContentLoaded', function () {
  console.log('[Swiper Init] DOMContentLoaded');

  const setupSwiper = () => {
    const swiperContainer = document.querySelector('.related-products-swiper');
    if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
      console.log('[Swiper Init] Inicializando Swiper en .related-products-swiper');

      new Swiper('.related-products-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: 2.5,
            spaceBetween: 24
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 32,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        }
      });

      swiperContainer.classList.add('swiper-initialized');
      console.log('[Swiper Init] Swiper inicializado');
    }
  };

  // Intenta inicializar (fallará si todavía no existe el contenedor)
  setupSwiper();

  // Observa cuando <product-recommendations> cambie
  const recommendationsComponent = document.querySelector('product-recommendations');

  if (recommendationsComponent) {
    console.log('[Swiper Init] Observando cambios en product-recommendations');

    const observer = new MutationObserver(() => {
      console.log('[Swiper Init] Se detectaron cambios en recomendaciones, reintentando Swiper');
      setupSwiper();
    });

    observer.observe(recommendationsComponent, {
      childList: true,
      subtree: true
    });
  } else {
    console.warn('[Swiper Init] No se encontró el componente <product-recommendations>.');
  }
});

const swiperTestimonials = new Swiper('.testimonials-swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  // loop: true,
  // loopedSlides: 4,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  breakpoints: {
    768: {
    slidesPerView: 3,
    spaceBetween: 35
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});